/** @jsx jsx */
import { jsx } from '@emotion/react';

type Props = {
  className?: string;
};

const ConduitSvg = ({ className }: Props) => (
  <svg
    className={className}
    width="991"
    height="988"
    viewBox="0 0 991 988"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M530.009 326.422L538.137 178.684C412.094 171.75 295.528 245.534 247.864 362.424C200.2 479.313 231.933 613.57 326.886 696.751C421.838 779.931 559.103 793.721 668.704 731.09C778.305 668.459 836.108 543.196 812.647 419.162L667.264 446.661C678.995 508.678 650.093 571.309 595.292 602.625C540.492 633.94 471.859 627.045 424.383 585.455C376.907 543.865 361.04 476.737 384.872 418.292C408.705 359.847 466.987 322.954 530.009 326.422Z"
      fill="url(#paint0_linear_conduit)"
    />
    <path
      d="M236.942 354.72C284.426 237.962 400.703 164.155 526.55 170.857L518.585 318.103C455.55 314.799 397.325 351.785 373.538 410.273C349.719 468.839 365.675 536.067 413.269 577.683C460.864 619.3 529.618 626.143 584.483 594.724C639.274 563.346 668.163 500.708 656.478 438.677L801.344 411.137C824.776 534.966 767.143 660.051 657.764 722.688C548.313 785.367 411.152 771.715 316.203 688.692C221.254 605.668 189.425 471.554 236.942 354.72Z"
      stroke="var(--cds-color-emphasis-primary-stroke-default)"
      strokeOpacity="0.08"
      strokeWidth="0.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_conduit"
        x1="606.202"
        y1="547.568"
        x2="673.121"
        y2="273.818"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--cds-color-emphasis-primary-background-xweak)" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default ConduitSvg;
